import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as featureFlags from '../../../../../../_augmentt/ducks/featureFlags'
import { getFeatureFlags } from '../../../../../crud/featureFlags.crud'
import { postMaesterDisplay } from '../../../../../crud/orgs.crud'

const updateMaesterDisplay = async ({ setError, setLoading, dispatch, params }) => {
  setLoading(true)
  setError(null)

  try {
    await postMaesterDisplay(params)
    const featureFlagsData = await getFeatureFlags()
    dispatch(featureFlags.actions.setFeatureFlags(featureFlagsData?.data))
  } catch (error) {
    console.error(error)
    setError(true)
  }

  setLoading(false)
}

const useMaesterDisplay = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const dispatch = useDispatch()

  // eslint-disable-next-line no-shadow
  const featureFlags = useSelector(({ featureFlags }) => featureFlags?.data)
  const isMaesterDisplayEnabled = featureFlags?.find((flag) => flag.feature === 'maester-display-results')?.enabled

  const updateMaesterDisplayCb = useCallback(
    (params) =>
      updateMaesterDisplay({
        setError,
        setLoading,
        dispatch,
        params,
      }),
    [dispatch],
  )

  return {
    loading,
    error,
    isMaesterDisplayEnabled,
    updateMaesterDisplayStatus: updateMaesterDisplayCb,
  }
}

export default useMaesterDisplay
